import React from 'react';

function pnlColor(profit) {
  if (profit > 0) return 'text-success';
  if (profit < 0) return 'text-danger';
  return 'text-muted';
}

function fmtPrice(v) {
  if (v == null || v === 0 || isNaN(v)) return '—';
  return v.toFixed(5);
}

function fmtPnl(v) {
  if (v == null || isNaN(v)) return '—';
  return `${v >= 0 ? '+' : ''}${v.toFixed(2)}`;
}

function fmtTime(d) {
  if (!d) return '—';
  const dt = new Date(d);
  const now = new Date();
  const sameDay = dt.toDateString() === now.toDateString();
  return sameDay
    ? dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : dt.toLocaleDateString([], { month: 'short', day: 'numeric' }) +
      ' ' + dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function TradeTable({ trades = [], showStatus = false }) {
  if (!trades.length) {
    return <p className="text-muted text-center py-4">No trades found.</p>;
  }

  return (
    <div className="table-responsive table-cards table-cards-wrap">
      <table className="table">
        <thead className="text-primary">
          <tr>
            <th>Symbol</th>
            <th>Type</th>
            <th className="num">Lots</th>
            <th className="num">Open</th>
            <th className="num">{showStatus ? 'Close' : 'Current'}</th>
            <th className="num">SL</th>
            <th className="num">TP</th>
            <th className="num">P&amp;L</th>
            <th>Time</th>
            <th className="num">Ticket</th>
            {showStatus && <th>Status</th>}
          </tr>
        </thead>
        <tbody>
          {trades.map(t => (
            <tr key={t._id || t.ticket}>
              <td data-label="Symbol"><strong>{t.symbol}</strong></td>
              <td data-label="Type">
                <span className={`badge badge-${t.type === 'buy' ? 'success' : 'danger'}`}>
                  {t.type?.toUpperCase()}
                </span>
              </td>
              <td data-label="Lots" className="num">{t.lots}</td>
              <td data-label="Open" className="num">{fmtPrice(t.openPrice)}</td>
              <td data-label={showStatus ? 'Close' : 'Current'} className="num">
                {fmtPrice(showStatus ? t.closePrice : t.currentPrice)}
              </td>
              <td data-label="SL" className="num">{t.sl > 0 ? t.sl.toFixed(5) : '—'}</td>
              <td data-label="TP" className="num">{t.tp > 0 ? t.tp.toFixed(5) : '—'}</td>
              <td data-label="P&L" className={`num ${pnlColor(t.profit)}`}>
                {fmtPnl(t.profit)}
              </td>
              <td data-label="Time" className="text-muted small">
                {fmtTime(t.openTime)}
              </td>
              <td data-label="Ticket" className="num text-muted">{t.ticket}</td>
              {showStatus && (
                <td data-label="Status">
                  <span className={`badge badge-${t.status === 'open' ? 'success' : 'secondary'}`}>{t.status}</span>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
